import { createAsyncThunk } from '@reduxjs/toolkit'
import { AccountInfo, getAccountInfo } from '../../../api/v1/account'
import { Address } from '../../../types'
import { RootState, store } from '../../index'
import authorization from '../../../utils/authorization'
import { updateAccountTickets, updateUserToken } from '../actions'
import toastify from 'components/Toastify'
import { disconnectLink } from 'store/link/actions'
import { updateSaveToken } from 'store/settings/actions'

export const getAccountInfoAction = createAsyncThunk<
  AccountInfo | null,
  {
    address: Address
    signature?: string
    pubKey?: string
  },
  {
    state: RootState
  }
>(
  'account/getAccountInfoAction',
  async ({ address, signature, pubKey }, { getState, dispatch }) => {
    const state = getState()
    const { tickets } = state.account
    if (tickets) {
      signature = signature ?? tickets.signature
      pubKey = pubKey ?? tickets.pubKey
    }
    const r = await getAccountInfo(address, signature, pubKey).catch((e) => {
      // If the user is not registered, save the address and signature to Redux.
      // Then use tickets to loop requests and listen for account info.
      // If the user deposits the currency to the account, it will respond with the account info and remove the tickets to stop the loop request.
      if (e.code === 1011 && e.msg === 'AUTH_USER_NOT_REGISTER') {
        store.dispatch(
          updateAccountTickets({
            address,
            signature: signature!,
            pubKey: pubKey!,
          }),
        )
      }

      if (e.code === 1003 && e.msg === 'ADDRESS_FORBIDDEN') {
        dispatch(disconnectLink())
        dispatch(updateSaveToken(false))
        return Promise.reject(
          'Please wait until the test is completed before using V3.',
        )
      }

      return null
    })

    if (!r) {
      return null
    }

    // code 200 is successfully login and authToken exists, then remove the tickets to stop loop requests.
    if (r.code === 200) {
      if (r.data?.authToken) {
        store.dispatch(updateAccountTickets(undefined))
        store.dispatch(updateUserToken(r.data.authToken))

        const state = store.getState()
        if (state.settings.save) {
          authorization.set(address, r.data.authToken)
        }
      }
    }

    return r.data
  },
)
